/* eslint-disable react-hooks/exhaustive-deps */
import { Filters } from 'components'

import constants from 'constants/index'

const SSOCoporateGroupFilter = ({ filter }) => {
  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Domínio" name="domain" />
      <input textfieldinput="true" label="Nome" name="name" />
      <select textfieldinput="true" label="Plataforma" name="platform">
        <option value=""></option>
        {constants.ssoCorporateGroups.PLATFORMS.map((platform) => (
          <option key={platform.id} value={platform.id}>
            {platform.name}
          </option>
        ))}
      </select>
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        {constants.ssoCorporateGroups.STATUSES.map((status) => (
          <option key={status.id} value={status.id}>
            {status.name}
          </option>
        ))}
      </select>
    </Filters>
  )
}

export default SSOCoporateGroupFilter
